import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { getAllTecnicos, getEquipo, updateEquipo } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { filterItems } from "../../../functions/funciones";
import { withRouter } from "../../../providers/withRouter";

const NuevoEquipoTecnicos = (props) => {
  const { t } = useTranslation('common');
  const [technicians, setTecnicos] = useState([]);

  const [busqueda, setBusqueda] = useState([]);
  const [resultados, setResultados] = useState();

  const [selected, setSelected] = useState([]);

  const [equipo, setEquipo] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  


  useEffect(() => {
    getEquipo(props.params.id).then(t => {
      setEquipo(t)
      
    })
    getAllTecnicos().then((res) => {
      const tecnicos = [];
      res.forEach((c) => {
        tecnicos.push({
          id: c.id,
          nif: c.nif,
          nombre: c.nombre,
          apellidos: c.apellidos,
          busqueda: c.nombre + " " + c.apellidos,
          userId: c.user?.id,
          team_id: c.team_id
        });
      });
      const id = parseInt(props.params.id)

      setResultados(tecnicos.filter(e => e.team_id !== id));
      setTecnicos(tecnicos);
      setSelected(tecnicos.filter(e => e.team_id === id))
      setIsLoading(false);

    });
  }, [])

  function handleSubmit(e) {
    e.preventDefault();
    const toastInfo = toast.info(t('teams.messages.editing'));
    // if (selected.length == 0) {
    //   return toast.update(toastInfo, {
    //     render: t('teams.messages.noTechnicians'),
    //     type: toast.TYPE.ERROR,
    //     autoClose: true,
    //   });
    // }
    updateEquipo({ ...equipo, userIds: selected.map(s => s.userId) })
      .then((res) => {
        if (res.status == 200) {
          toast.update(toastInfo, {
            render: t('teams.messages.editedSuccess'),
            type: toast.TYPE.SUCCESS,
            autoClose: true,
          });

          setTimeout(() => {
            window.location.replace("/equipos");
          }, 3000);
        } else if (res.status == 403) {
          toast.update(toastInfo, {
            render: t('teams.messages.createError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        } else {
          toast.update(toastInfo, {
            render: t('teams.messages.unknownError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        }


      })
      .catch((err) => {
        console.log(err);
        toast.error(t('teams.messages.createError'));
      });
  }
  function handleChange(evt) {
    const value = evt.target.value;
    setEquipo({
      ...equipo,
      [evt.target.name]: value,
    });
  }


  const buscar = (e) => {
    // e.preventDefault();

    setResultados(filterItems(busqueda, technicians.filter(c => !selected.some(s => s.id === c.id))))
  };
  useEffect(buscar, [busqueda]);

  const select = (tecnico) => {
    setSelected([...selected, tecnico]);
    setResultados(resultados.filter(c => c.id !== tecnico.id));
  }

  const unselect = (tecnico) => {
    const newSelected = selected.filter(c => c.id !== tecnico.id)
    setSelected(newSelected);
    setResultados(technicians.filter(c => !newSelected.some(s => s.id === c.id)));
  }


  return (
    <>
      {/* <div
        className="pageHeader"
        style={{
          backgroundImage: `url(${HeaderBackground})`,
          textAlign: "left",
        }}
      >
        tecnicos / <b>Nuevo</b>
      </div> */}
      <BreadCrumb rutas={[{ path: `/tecnicos`, label: t('technicians.title') }, { path: `/equipos`, label: t('teams.new') }]} style={{ margin: '0 10px' }} />
      <div className="pageContent">
        <div className="gridHead">{t('teams.editTeam')}</div>
        <form className="nuevoAAFFForm" onSubmit={handleSubmit}>
          <input
            type="text"
            required
            placeholder={t('form.name')}
            name="nombre"
            value={equipo?.nombre}
            onChange={handleChange}
          ></input>

          <div className="tableContainer" style={{ marginTop: 30, marginBottom: 30, padding: 0 }}>
            <table>

              <thead>
                <tr>
                  <th>{t('teams.columns.technician')}</th>
                  <th>{t('teams.columns.nif')}</th>
                  <th style={{ textAlign: "center" }}>{t('teams.columns.delete')}</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      <CircularProgress style={{ color: '#92004D' }} />
                    </td>
                  </tr>
                ) :
                  selected.length == 0 ? <tr><td colSpan={3} style={{ textAlign: "center" }}>{t('teams.messages.selectTechnicians')}</td></tr> : selected.map((e, i) => {
                    return (
                      <tr key={i}>
                        <td>{e.nombre + " " + e.apellidos}</td>
                        <td>{e.nif}</td>
                        <td style={{ textAlign: "center" }}>
                          <div
                            className="asignarButton"
                            style={{
                              marginLeft: "auto",
                              marginRight: "auto",
                              cursor: "pointer",
                            }}
                            onClick={() => unselect(e)}
                          >
                            {t('actions.delete')}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

            </table>
          </div>
          <input
            type="submit"
            value={t('actions.save')}
          ></input>
        </form>
        <form className="nuevoAAFFForm" onSubmit={e => e.preventDefault()}>
          <input
            type="text"
            placeholder={t('teams.searchTechnician')}
            required
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          ></input>
        </form>
        <div className="tableContainer" style={{ marginTop: 10 }}>
          <table>
            <thead>
              <tr>
                <th>{t('teams.columns.technician')}</th>
                <th>{t('teams.columns.nif')}</th>
                <th style={{ textAlign: "center" }}>{t('teams.columns.add')}</th>
              </tr>
            </thead>
            <tbody>
            {isLoading ? (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      <CircularProgress style={{ color: '#92004D' }} />
                    </td>
                  </tr>
                ) :
              Array.isArray(resultados) ? resultados.map((e, i) => {
                return (
                  <tr key={i}>
                    <td>{e.nombre + " " + e.apellidos}</td>
                    <td>{e.nif}</td>
                    <td style={{ textAlign: "center" }}>
                      <div
                        className="asignarButton"
                        style={{
                          marginLeft: "auto",
                          marginRight: "auto",
                          cursor: "pointer",
                        }}
                        onClick={() => select(e)}
                      >
                        {t('actions.add')}
                      </div>
                    </td>
                  </tr>
                );
              }) :
                <tr><td colSpan={3} style={{ textAlign: "center" }}><CircularProgress style={{ color: '#92004D' }} /></td></tr>
              }
            </tbody>
          </table>
        </div>

      </div>
    </>
  );
};

export default withRouter(NuevoEquipoTecnicos);